// wp-icons — UI/Layout extras (11)
// Menu, MoreHorizontal, MoreVertical, Filter, Search, Eye, EyeOff leben in layout.js
import { createWpIcon } from './createIcon.js';

export const GripVertical = createWpIcon('GripVertical', [
  ['circle', { cx: 9, cy: 5, r: 1, key: 'a' }],
  ['circle', { cx: 9, cy: 12, r: 1, key: 'b' }],
  ['circle', { cx: 9, cy: 19, r: 1, key: 'c' }],
  ['circle', { cx: 15, cy: 5, r: 1, key: 'd' }],
  ['circle', { cx: 15, cy: 12, r: 1, key: 'e' }],
  ['circle', { cx: 15, cy: 19, r: 1, key: 'f' }],
]);
export const Maximize2 = createWpIcon('Maximize2', [
  ['polyline', { points: '15 3 21 3 21 9', key: 'a' }],
  ['polyline', { points: '9 21 3 21 3 15', key: 'b' }],
  ['line', { x1: 21, x2: 14, y1: 3, y2: 10, key: 'c' }],
  ['line', { x1: 3, x2: 10, y1: 21, y2: 14, key: 'd' }],
]);
export const Minimize2 = createWpIcon('Minimize2', [
  ['polyline', { points: '4 14 10 14 10 20', key: 'a' }],
  ['polyline', { points: '20 10 14 10 14 4', key: 'b' }],
  ['line', { x1: 14, x2: 21, y1: 10, y2: 3, key: 'c' }],
  ['line', { x1: 3, x2: 10, y1: 21, y2: 14, key: 'd' }],
]);
export const PanelLeftOpen = createWpIcon('PanelLeftOpen', [
  ['rect', { width: 18, height: 18, x: 3, y: 3, rx: 2, key: 'a' }],
  ['path', { d: 'M9 3v18', key: 'b' }],
  ['path', { d: 'm14 9 3 3-3 3', key: 'c' }],
]);
export const PanelRightOpen = createWpIcon('PanelRightOpen', [
  ['rect', { width: 18, height: 18, x: 3, y: 3, rx: 2, key: 'a' }],
  ['path', { d: 'M15 3v18', key: 'b' }],
  ['path', { d: 'm10 15-3-3 3-3', key: 'c' }],
]);
export const ToggleLeft = createWpIcon('ToggleLeft', [
  ['rect', { width: 20, height: 12, x: 2, y: 6, rx: 6, ry: 6, key: 'a' }],
  ['circle', { cx: 8, cy: 12, r: 2, key: 'b' }],
]);
export const ToggleRight = createWpIcon('ToggleRight', [
  ['rect', { width: 20, height: 12, x: 2, y: 6, rx: 6, ry: 6, key: 'a' }],
  ['circle', { cx: 16, cy: 12, r: 2, key: 'b' }],
]);
export const Keyboard = createWpIcon('Keyboard', [
  ['path', { d: 'M10 8h.01', key: 'a' }],
  ['path', { d: 'M12 12h.01', key: 'b' }],
  ['path', { d: 'M14 8h.01', key: 'c' }],
  ['path', { d: 'M16 12h.01', key: 'd' }],
  ['path', { d: 'M18 8h.01', key: 'e' }],
  ['path', { d: 'M6 8h.01', key: 'f' }],
  ['path', { d: 'M7 16h10', key: 'g' }],
  ['path', { d: 'M8 12h.01', key: 'h' }],
  ['rect', { width: 20, height: 16, x: 2, y: 4, rx: 2, key: 'i' }],
]);
export const ExternalLink = createWpIcon('ExternalLink', [
  ['path', { d: 'M15 3h6v6', key: 'a' }],
  ['path', { d: 'M10 14 21 3', key: 'b' }],
  ['path', { d: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6', key: 'c' }],
]);
export const Link2 = createWpIcon('Link2', [
  ['path', { d: 'M9 17H7A5 5 0 0 1 7 7h2', key: 'a' }],
  ['path', { d: 'M15 7h2a5 5 0 1 1 0 10h-2', key: 'b' }],
  ['line', { x1: 8, x2: 16, y1: 12, y2: 12, key: 'c' }],
]);
export const Unlink = createWpIcon('Unlink', [
  ['path', { d: 'm18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71', key: 'a' }],
  ['path', { d: 'm5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71', key: 'b' }],
  ['line', { x1: 8, x2: 8, y1: 2, y2: 5, key: 'c' }],
  ['line', { x1: 2, x2: 5, y1: 8, y2: 8, key: 'd' }],
  ['line', { x1: 16, x2: 16, y1: 19, y2: 22, key: 'e' }],
  ['line', { x1: 19, x2: 22, y1: 16, y2: 16, key: 'f' }],
]);
